import { getContextBg } from "shared/helpers/ssr"
// import { formInitDataString } from "./formInitDataString"
import { getHeadTemplate } from "./getHeadTemplate"


export const ssrGetPageTemplate = (indexHTML: string, objProps: any, params: any) => {
    const { ssrProps, activeRoute } = params || {}
    // if(ssrProps) {
    //     const htmlData = formInitDataString(ssrProps)
    //     indexHTML = indexHTML.replace('<script id="initData"></script>', `<script id="initData">${htmlData}</script>`);
    // }
    const headTemplate = getHeadTemplate({ props: ssrProps, activeRoute, objProps })
    if (headTemplate) {
        indexHTML = indexHTML.replace('<head>', `<head>${headTemplate}</script>`);
    }
    const contextBg = getContextBg(objProps, params)
    if(contextBg) {
        indexHTML = indexHTML.replace('app-wrapper"', `app-wrapper" style="background: ${contextBg}; width: 100vw; height: 100vh;"`)
        indexHTML = indexHTML.replace('app-content"', `app-content" style="opacity: 0;"`)
    } 
    return indexHTML
}import { getContextBg } from "shared/helpers/ssr"
// import { formInitDataString } from "./formInitDataString"
import { getHeadTemplate } from "./getHeadTemplate"


export const ssrGetPageTemplate = (indexHTML: string, objProps: any, params: any) => {
    const { ssrProps, activeRoute } = params || {}
    // if(ssrProps) {
    //     const htmlData = formInitDataString(ssrProps)
    //     indexHTML = indexHTML.replace('<script id="initData"></script>', `<script id="initData">${htmlData}</script>`);
    // }
    const headTemplate = getHeadTemplate({ props: ssrProps, activeRoute, objProps })
    if (headTemplate) {
        indexHTML = indexHTML.replace('<head>', `<head>${headTemplate}</script>`);
    }
    const contextBg = getContextBg(objProps, params)
    if(contextBg) {
        indexHTML = indexHTML.replace('app-wrapper"', `app-wrapper" style="background: ${contextBg}; width: 100vw; height: 100vh;"`)
        indexHTML = indexHTML.replace('app-content"', `app-content" style="opacity: 0;"`)
    } 
    return indexHTML
}